import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initInformationImagesSlider() {
  Alpine.data(
    'informationImagesSlider',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.informationImagesSlider__swiper');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          loop: true,
          autoHeight: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          spaceBetween: 30,
          slidesPerView: 1,
          lazyPreloadPrevNext: 2,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .informationImagesSlider__next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .informationImagesSlider__prev`,
          },
        });
      },
    }),
  );
}
